import React from 'react';
import { AppNordCard } from '@/components/ui/AppNordCard'; // Assuming Nord Card wrapper

interface EmergencyContactProps {
  // Accept emergency contact data as props
  name: string | null | undefined;
  phone: string | null | undefined;
  relationship: string | null | undefined;
  // Add onEdit callback if needed
  // onEdit?: () => void;
}

const EmergencyContact: React.FC<EmergencyContactProps> = ({
  name,
  phone,
  relationship,
  // onEdit
}) => {
  // TODO: Add state and form fields for editing functionality later

  return (
    <AppNordCard>
      <div className="flex justify-between items-center mb-4">
        <h4 className="nord-heading-m">Emergency Contact</h4>
        {/* Add edit button if implementing editing */}
        {/* <AppNordButton variant="secondary" size="s" onClick={onEdit}>Edit</AppNordButton> */}
      </div>
      {name || phone || relationship ? (
        <div className="space-y-2">
          <div>
            <p className="text-sm text-[var(--text-secondary)]">Name</p>
            <p className="text-[var(--text-primary)] font-medium">
              {name || 'Not provided'}
            </p>
          </div>
          <div>
            <p className="text-sm text-[var(--text-secondary)]">Phone</p>
            <p className="text-[var(--text-primary)] font-medium">
              {phone || 'Not provided'}
            </p>
          </div>
          <div>
            <p className="text-sm text-[var(--text-secondary)]">Relationship</p>
            <p className="text-[var(--text-primary)] font-medium">
              {relationship || 'Not provided'}
            </p>
          </div>
        </div>
      ) : (
        <p className="text-[var(--text-secondary)]">
          No emergency contact information provided.
          {/* Add a button to prompt adding info if needed */}
        </p>
      )}
    </AppNordCard>
  );
};

export default EmergencyContact; 